<script lang="ts">
    import { v4 as uuidv4 } from 'uuid';
    import { Button, Icon, Input, InputGroup } from "sveltestrap";
    import type { Vehicle } from "../Model/Vehicle";
    import { Link, navigate } from "svelte-navigator";
    import AppWraper from "../components/AppWraper.svelte";
    import { vehiclesService } from '../services';
    import ParamName from '../components/ParamName.svelte';

    export const editVehicle = null;

    let vehicles: Vehicle[];
    
    let offset = 0;
    let limit = 25;
    let searchFilter = null;

    // const dispatch = createEventDispatcher();

    load()

    async function load(){

        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: searchFilter
            }
        }

        vehicles = await vehiclesService.findVehicles(opts);

        vehicles.sort((a,b) => {
            return a.markId < b.markId ? -1 : 1;
        })
        
    }

    function vehicleUpdate(vehicle: Vehicle): void {
        let vehicleAct = vehicles.find(u => u.id == vehicle.id)

        if (vehicleAct) {
            vehicleAct = vehicle
            vehicles = vehicles;
        }
    }

    async function showmoreVehicles(): Promise<void> {
        offset = offset + limit

        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: searchFilter
            }
        }

        const vehiclesMore = await vehiclesService.findVehicles(opts);

        vehiclesMore.sort((a,b) => {
            return a.markId < b.markId ? -1 : 1;
        })

        vehiclesMore.forEach(t => {
            vehicles.push(t);
        });

        vehicles = vehicles;
    }

    function newVehicle(){
        navigate('/vehiculo/new');
	}

</script>

<style>

</style>

<AppWraper>
    <div class="container-fluid p-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-9 mb-3">
                    <div class="text-start">
                        <h3>Listado de Vehículos</h3>
                    </div>
                  </div>
              <div class="col-12 col-sm-3 mb-3">
                <div class="text-end">
                    <Button color="primary" on:click={() => newVehicle()}>
                        Nuevo Vehículo
                    </Button>
                </div>
              </div>
              <div class="col-12 col-sm-6 mb-3">
                  <form on:submit|preventDefault={() => load()}>
                    <InputGroup>
                        <Input placeholder="Encuentra un vehículo" bind:value={searchFilter} />
                        <button type="submit" class="btn btn-primary"><Icon name="search" /></button>
                      </InputGroup>
                  </form>
              </div>
              <div class="col-12">
                {#if vehicles?.length}
                <table class="table">
                    <thead>
                        
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">Matrícula</th>
                                <th scope="col">Bastidor</th>
                                <th scope="col">Tipo</th>
                                <th scope='col'>Marca/Modelos</th>
                            </tr>
                
                    </thead>
                    <tbody>
                        {#each vehicles as vehicle, index }
                            <tr>
                                <th scope="row">{index + 1}</th>
                                <td>
                                    <Link to="/vehiculo/{vehicle.id}">
                                        {vehicle.plate}
                                    </Link>
                                </td>
                                <td>{vehicle.frame}</td>
                                <td>
                                    <ParamName id={vehicle.vehicleType} />
                                </td>
                                <td>
                                    <ParamName id={vehicle.markId} />  <ParamName id={vehicle.modelId} />
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
                <div class="col-12 text-center">
                    <button class="btn btn-primary btn-sm" type="button" on:click={() => showmoreVehicles()} >Ver más</button>
                </div>
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h3>No hay Terceros para mostrar</h3>
                </div>
            {/if}
              </div>
            </div>
        </div>
    </div>
    
    <!-- <VehicleModal Vehicle={editVehicle}  on:VehicleUpdate={() => VehicleUpdate(editVehicle)}/> -->

</AppWraper>




